
import { useNavigate, useLocation } from 'react-router-dom';

export default function BottomNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { id: 'home', icon: 'ri-home-line', activeIcon: 'ri-home-fill', label: 'الرئيسية', path: '/' },
    { id: 'categories', icon: 'ri-grid-line', activeIcon: 'ri-grid-fill', label: 'الأقسام', path: '/categories' },
    { id: 'orders', icon: 'ri-file-list-line', activeIcon: 'ri-file-list-fill', label: 'طلباتي', path: '/orders' },
    { id: 'profile', icon: 'ri-user-line', activeIcon: 'ri-user-fill', label: 'الملف الشخصي', path: '/profile' }
  ];

  return (
    <nav className="fixed bottom-0 w-full bg-white border-t border-gray-200 z-50">
      <div className="grid grid-cols-4 h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center space-y-1 transition-colors duration-200 ${
                isActive ? 'text-[#D4AF37]' : 'text-[#777777]'
              }`}
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${isActive ? item.activeIcon : item.icon} text-lg`}></i>
              </div>
              <span className="text-xs font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
